import { z } from 'zod';

export const buildVersionSchema = z.string().regex(/^[0-9a-f]{7,40}$/);
